import styled from 'styled-components'
import { Text } from 'components/atoms/Typography'
import { COLORS } from 'config/constants'

const Link = styled(Text)`
  cursor: pointer;
  text-decoration: none;
  :hover {
    color: ${({ hoverColor }) => COLORS[hoverColor] || hoverColor};
  }
`

Link.defaultProps = {
  as: 'a',
  color: 'heading',
  hoverColor: COLORS.ARAGON_GREEN,
}

export default Link
